import Qs from 'qs'

/**
 * Parse a query string into an object.
 *
 * @param {String} The query string to parse.
 * @param {Object} The parse options.
 * @return {Object} The parsed query object.
 */
export const parseQuery = Qs.parse.bind(Qs)

/**
 * Serialize an object into a query string.
 *
 * @param {Object} The object to serialize.
 * @param {Object} The serialize options.
 * @return {String} The serialized query string.
 */
export const stringifyQuery = Qs.stringify.bind(Qs)

/**
 * Parse a URL and return its components.
 *
 * @param url {String} The URL to parse.
 * @returns {Object} The parsed URL.
 */
export function parseUrl(url: string): HTMLHyperlinkElementUtils {
  const anchor = document.createElement('a')

  anchor.href = url

  return anchor
}
